import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { MdEdit } from "react-icons/md";
import { LiaFileDownloadSolid } from "react-icons/lia";
import Layout from "layout";
import services from 'API/services';
import { authenticationSeletor } from "store/slices/authenticationSlice";
import { createPropertyLogs } from "store/slices/PropertyData";

const DSRPage = () => {

    const dispatch = useDispatch();
    const today = new Date();

    const { register, handleSubmit, reset, setValue, setFocus, formState: { errors, isSubmitting } } = useForm();
    const { userDetail } = useSelector(authenticationSeletor);
    const [activeTab, setActiveTab] = useState('balance')
    const [dsrData, setDsrData] = useState([]);
    const [selected, setSelected] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [dayCloserData, setDayCloserData] = useState([]);

    const fetchDsr = async () => {
        try {
            const res = await services.property.getDsrService(userDetail?.propertyId);

            if (res?.data?.status === true) {
                setDsrData(res?.data?.data)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchDsr();
    }, [])

    const onSubmit = async (payload) => {
        try {
            const data = {
                openBalance: payload.openBalance,
                remark: payload.remark,
            }
            if (editMode) {
                data.updatedBy = userDetail?.id
            }
            else {
                data.createdBy = userDetail?.id
                data.propertyId = userDetail?.propertyId
            }
            const res = editMode ? await services.property.editDsrService(selected?.id, data) : await services.property.createDsrService(data);
            if (res?.data?.status === true) {
                let operation = {
                    Date: today,
                    Balance: payload.openBalance,
                    Remark: payload.remark
                };
                if (editMode) {
                    operation = {};
                    if (selected?.openBalance != payload.openBalance) {
                        operation.Balance = `${selected?.openBalance} → ${payload.openBalance}`;
                    }
                    if (selected?.remark != payload.remark) {
                        operation.Remark = `${selected?.remark} → ${payload.remark}`;
                    }
                }
                const params = {
                    action: `DSR ${editMode ? 'Modified' : 'Created'}`,
                    actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
                    operation: JSON.stringify(operation),
                    propertyId: userDetail?.propertyId
                };
                dispatch(createPropertyLogs(params))

                toast.success(`DSR ${editMode ? "Updated" : "Created"} Successfully`);
                reset();
                setEditMode(false);
                setSelected({})
                fetchDsr();
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    const handleEditDsr = (item) => {
        setEditMode(true);
        setSelected(item);
        setValue("openBalance", item.openBalance);
        setValue("remark", item.remark);
        setFocus("openBalance");
    };


    const fetchDayCloser = async () => {
        try {
            const res = await services.property.getDayCloserService(userDetail?.propertyId)
            if (res?.data?.status === true) {
                setDayCloserData(res?.data?.data)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchDayCloser();
    }, [])

    console.log('selected', selected)

    return (
        <Layout title="DSR">
            <div className='dsr-page'>
                <div className='dsr-tab'>
                    <ul>
                        <li
                            className={activeTab == 'balance' ? 'active' : ''}
                            onClick={() => setActiveTab('balance')}>
                            Opening Balance
                        </li>
                        <li
                            className={activeTab == 'day' ? 'active' : ''}
                            onClick={() => setActiveTab('day')}>
                            Day Closer
                        </li>
                    </ul>
                </div>
                {
                    activeTab == 'balance' && (
                        <>
                            <div className='dsr-head'>
                                <div className='row align-items-center'>
                                    <div className='col-xl-6 col-lg-4 col-md-3'>
                                        <h2 className='mb-0'>Opening Balance</h2>
                                    </div>
                                    <div className='col-xl-6 col-lg-8 col-md-9'>
                                        <form className='flex row-sm' onSubmit={handleSubmit(onSubmit)}>
                                            <div className='col-lg-3 col-md-3'>
                                                <label className='field-label'>Date</label>
                                                <input type='text' value={moment(today).format('DD-MM-YYYY')} className='field-control' readOnly />
                                            </div>
                                            <div className='col-lg-3 col-md-3'>
                                                <label className='field-label'>Opening Balance </label>
                                                <input
                                                    type="number"
                                                    className="field-control"
                                                    onWheel={(e) => e.target.blur()}
                                                    {...register("openBalance", {
                                                        required: true,
                                                        min: 0
                                                    })}
                                                    placeholder="Enter Opening Balance"
                                                />
                                                {errors.openBalance && <span className='error-text lh-base mt-0'>Opening balance is required</span>}
                                            </div>
                                            <div className='col-lg-4 col-md-3'>
                                                <label className='field-label'>Remark</label>
                                                <input
                                                    type="text"
                                                    className="field-control"
                                                    {...register("remark", { required: true })}
                                                    placeholder="Enter Opening Balance"
                                                />
                                                {errors.remark && <span className='error-text lh-base mt-0'>Remark is required</span>}
                                            </div>
                                            <div className='col-lg-2 col-md-3'>
                                                <label className='field-label opacity-0'>Button</label>
                                                <button type='submit' disabled={isSubmitting} className='btn btn-site btn-block'>
                                                    {isSubmitting ? "Please wait..." : editMode ? "Update" : "Submit"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className='dsr-body'>
                                <div className='flex row'>
                                    {dsrData.length > 0 ?
                                        dsrData?.map((item) => {
                                            return (
                                                <div className='col-xl-2 col-lg-4 col-md-6 col-sm-6 column' key={item?.id}>
                                                    <div className={`info-card ${selected?.id == item?.id ? 'active' : ''}`}>
                                                        <span className='btn-edit all-center' onClick={() => handleEditDsr(item)}><MdEdit /></span>
                                                        <h5>Date - {moment(item?.createdAt).format('DD-MM-YYYY')}</h5>
                                                        <p>Balance - <span className='text-success fw-bold'>₹ {item?.openBalance}</span></p>
                                                        <p className='pt-1'>Remark - {item?.remark}</p>
                                                    </div>
                                                </div>
                                            )
                                        }) : <div className='text-center pb-3'>No Data Found</div>
                                    }
                                </div>
                            </div>
                        </>
                    )
                }
                {
                    activeTab == 'day' && (
                        <div className='dsr-body'>
                            <h2 className='mb-3'>Day Closer</h2>
                            <div className='flex row'>
                                {
                                    dayCloserData?.map((item) => {
                                        return (
                                            <div className='col-xl-2 col-lg-4 col-md-6 col-sm-6 column' key={item?.id}>
                                                <div className='info-card'>
                                                    <h5>Date</h5>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <p>{moment(item?.date).format('DD-MM-YYYY')}</p>
                                                        <a href={item?.report} target='_blank' className='btn p-0'>
                                                            <LiaFileDownloadSolid size={22} className='text-primary' />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </Layout>
    )
}

export default DSRPage;